interface SpinnerProps {
  /** Tailwind size class, e.g. 'h-4 w-4'. Defaults to 'h-5 w-5'. */
  className?: string;
  label?: string;
}

/**
 * Small CSS-only spinner. `aria-live="polite"` + `role="status"` so screen
 * readers announce loading state without stealing focus.
 */
export function Spinner({ className = 'h-5 w-5', label = 'Loading' }: SpinnerProps) {
  return (
    <span role="status" aria-live="polite" className="inline-flex items-center gap-2">
      <svg
        className={`animate-spin ${className}`}
        viewBox="0 0 24 24"
        fill="none"
        aria-hidden="true"
      >
        <circle cx="12" cy="12" r="10" stroke="currentColor" strokeOpacity="0.2" strokeWidth="4" />
        <path
          d="M4 12a8 8 0 018-8"
          stroke="currentColor"
          strokeWidth="4"
          strokeLinecap="round"
        />
      </svg>
      <span className="sr-only">{label}</span>
    </span>
  );
}
